import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from './ui/dialog';
import { Button } from './ui/Button';

interface DeleteDictionaryEntryDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  word: string;
  onConfirm: () => void;
  isDeleting: boolean;
}

export function DeleteDictionaryEntryDialog({
  open,
  onOpenChange,
  word,
  onConfirm,
  isDeleting,
}: DeleteDictionaryEntryDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Delete Dictionary Entry</DialogTitle>
          <DialogDescription>
            Remove <span className="font-mono font-medium text-foreground">'{word}'</span> from the
            dictionary? Open cases will be re-scanned to reflect this change.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={isDeleting}>
            Cancel
          </Button>
          <Button
            className="bg-red-600 hover:bg-red-700 text-white"
            onClick={onConfirm}
            disabled={isDeleting}
          >
            {isDeleting ? 'Deleting...' : 'Delete'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
